import { useLocation, useParams } from "react-router";
import { useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import CommonHeader from "../containers/CommonHeader";
import { Image } from "react-bootstrap";
import useGoTo from "../hooks/useGoTo";

export default function ProductImageScreen() {
  const goTo = useGoTo();
  const params = useParams();
  const { state } = useLocation();
  const productId = parseInt(params.productId, 10);
  const product = useSelector((state) =>
    state.products.items.find((p) => p.id === productId),
  );

  if (!product) {
    return (
      <>
        <CommonHeader text="Detalhes do produto" />
        <Container className="text-center mt-3 mb-3">
          <h1>Ops...</h1>
          <p>Este produto não existe mais.</p>
        </Container>
      </>
    );
  }

  const goToProduct = () => {
    goTo(`/product/${product.id}`, state);
    return false;
  };

  return (
    <>
      <CommonHeader text={product.name} onBack={goToProduct} />
      <Container className="px-5 text-center">
        <Image src={product.pictureUrl} alt="Ilustração do produto" fluid />;
      </Container>
    </>
  );
}
